import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { AppLinksComponent } from './widgets/app-links/app-links.component';
import { LegacyAppLinksComponent } from './widgets/legacy-app-links/legacy-app-links.component';
import { CaseListComponent } from './widgets/case-list/case-list.component';

import { DashboardComponent } from './dashboard.component';
import { SeDashboardComponent } from './se-dashboard/se-dashboard.component';
import { SystemUsageTabComponent } from './system-usage-tab/system-usage-tab.component';
import { ScoreclassTabComponent } from './scoreclass-tab/scoreclass-tab.component';
import { DashboardFiltersComponent } from './dashboard-filters/dashboard-filters.component';
import { Top5Component } from './widgets/top5/top5.component';
import { TopOppsComponent } from './widgets/top-opps/top-opps.component';
import { TimeSensitiveComponent } from './widgets/time-sensitive/time-sensitive.component';
import { FollowUpComponent } from './widgets/followUp/followUp.component';
import { MessagesComponent } from './widgets/messages/messages.component';
import { ScorecardComponent } from './widgets/scorecard/scorecard.component';
import { TopBridgesComponent } from './widgets/topBridges/topBridges.component';
import { UploaderComponent } from './widgets/uploader/uploader.component';
import { LifeStatsComponent } from './widgets/life-stats/life-stats.component';
import { UnitProductStatsComponent } from './widgets/unitProductStats/unitProductStats.component';
import { HighActivityStatsComponent } from './widgets/highActivityStats/highActivityStats.component';
import { FundComparisonComponent } from './widgets/fund-comparison/fund-comparison.component';
import { CaseStatsComponent } from './widgets/caseStats/caseStats.component';
import { CaseStatsActivityComponent } from './widgets/caseStatsActivity/caseStatsActivity.component';
import { SummaryChartsComponent } from './widgets/summaryCharts/summaryCharts.component';
import { CasesByScoreclassComponent } from './widgets/casesByScoreclass/casesByScoreclass.component';
import { Top5SummaryComponent } from './widgets/top5Summary/top5Summary.component';
import { SystemUsageSummaryComponent } from './widgets/systemUsageSummary/systemUsageSummary.component';

import { DashboardService } from './dashboard.service';

import { DashRouting } from './dashboard-routing.module';
import { AnnuitiesComponent } from './widgets/annuities/annuities.component';
import { FiaRatesComponent } from './widgets/fia-rates/fia-rates.component';
import { ViaRatesComponent } from './widgets/via-rates/via-rates.component';
import { LivingBenefitsComponent } from './widgets/living-benefits/living-benefits.component';
import { DeathBenefitsComponent } from './widgets/death-benefits/death-benefits.component';
import { PpfaComponent } from './widgets/ppfa/ppfa.component';
import { ActivePPfaComponent } from './widgets/activeppfa/activeppfa.component';
import { FiaActiveRatesComponent } from './widgets/fiaactiverates/fiaactiverates.component';
import { SystemUsageComponent } from './widgets/systemUsage/systemUsage.component';
// import { HighchartsChartModule } from 'highcharts-angular';
import { AnnuitiesByConnectorComponent } from './widgets/annuities-by-connector/annuities-by-connector.component';
import { ViaActiveRatesComponent } from './widgets/via-active-rates/via-active-rates.component';
import { FixedAnnuitiesActiveRatesComponent } from './widgets/fixed-annuities-active-rates/fixed-annuities-active-rates.component';
import { CaseUsageComponent } from './widgets/case-usage/case-usage.component';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { RecommendedProductsTabComponent } from './recommended-products/recommended-products-tab.component';
import { MaskitoDirective } from '@maskito/angular';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    FormsModule,
    DashRouting,
    // HighchartsChartModule,
    GridModule,
    ExcelModule,
    MultiSelectModule,
    InputsModule,
    DatePickerModule,
    MaskitoDirective,
  ],
  declarations: [
    AppLinksComponent,
    LegacyAppLinksComponent,
    CaseListComponent,
    DashboardComponent,
    SeDashboardComponent,
    DashboardFiltersComponent,
    SystemUsageTabComponent,
    RecommendedProductsTabComponent,
    ScoreclassTabComponent,
    Top5Component,
    TopOppsComponent,
    TimeSensitiveComponent,
    FollowUpComponent,
    MessagesComponent,
    ScorecardComponent,
    TopBridgesComponent,
    UploaderComponent,
    LifeStatsComponent,
    UnitProductStatsComponent,
    HighActivityStatsComponent,
    AnnuitiesComponent,
    FiaRatesComponent,
    ViaRatesComponent,
    LivingBenefitsComponent,
    DeathBenefitsComponent,
    AnnuitiesByConnectorComponent,
    FixedAnnuitiesActiveRatesComponent,
    ViaActiveRatesComponent,
    PpfaComponent,
    FundComparisonComponent,
    CaseStatsComponent,
    CaseStatsActivityComponent,
    ActivePPfaComponent,
    FiaActiveRatesComponent,
    SystemUsageComponent,
    SummaryChartsComponent,
    CasesByScoreclassComponent,
    Top5SummaryComponent,
    SystemUsageSummaryComponent,
    CaseUsageComponent,
  ],
  exports: [],
})
export class DashboardModule {}
